import React from "react";


export default function Footer() {
  return (
    <div bgColor="rgb(166, 18, 189)" className="text-center text-lg-start text-muted mt-4">
      <div
        className="text-center p-4"
        style={{ backgroundColor: "rgba(166, 18, 189, 0.911)", color:"whitesmoke"}}
        
      >
        © 2023 Copyright:
        <span  >🎥Movies Tickets🍿</span>
      </div>
    </div>
  );
}
